import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Box, Stack, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import { ButtonsPrimary, ButtonsSecondary, ButtonsTertiary } from '../../ComponentApp/buttoms';
import Spinner from '../../Spinner';
import {
  ContentTitleTable,
  TitleTableName,
} from '../../portfolio/portolioInvestment/PortfolioInvestmentComponents';
import {
  BtnContainer,
  BtnGroupContainer,
  BtnGroupFunds,
  ChartWrapper,
  InvestmentActionContainer,
  InvestmentContentContainer,
  CardContainerMovements,
} from '../productsDetails/ProductsStyledComponents';
import ChartnvestmentContainerProducts from './ChartnvestmentContainerProducts';
import DividendDropDownProducts from './DividendDropDownProducts';
import SectionGeneralCondition from './SectionGeneralCondition';
import TableInvertedProducts from './TableInvertedProducts';

const colores = {
  'HMC Balanceado Global': '#8612FF',
  'HMC Deuda Privada Pesos': '#160BE3',
  'HMC Renta Global Pesos': '#0060FA',
  'HMC Global Real Estate Income': '#0BBAE3',
  'HMC US Venture Opportunities': '#0DFBBD',
  'HMC Deuda Privada Global': '#D98DEB',
  'HMC Renta Global USD': '#FFAF9C',
  Caja: 'rgba(30, 34, 170, 1)',
  // ...asocia cada security con un color
};

const BodyInvertedProducts = ({
  dataCharts,
  dividends,
  myInvestment,
  idSelected,
  valorCuota,
  onChangeMonths,
  active,
  loadingGetSecurityPriceRange,
  successGetSecurityTransactions,
  loadingGetSecurityTransactions,
  handleRescueInvestment,
  handleInvestMore,
  ModelId,
  fileAs,
  handleOpen,
  statusDividendFinfolio,
  simulation = ' Rescatar Inversión',
  investmentMore = ' Invertir Más',
  refetch,
  handleClose,
  visible,
}) => {
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const completedTransactions = successGetSecurityTransactions
    .filter(item => item.status === 4)
    .sort((a, b) => new Date(b.tradeDate) - new Date(a.tradeDate));

  const pendingTransactions = successGetSecurityTransactions
    .filter(item => item.status === 2 || item.status === 1)
    .sort((a, b) => new Date(b.tradeDate) - new Date(a.tradeDate));

  if (loadingGetSecurityTransactions) {
    return <Spinner />;
  }

  return (
    <Stack
      sx={{
        width: '90%',
        marginTop: '48px',
        borderRadius: '16px',
        position: 'relative',
        marginX: 'auto',
        isolation: 'isolate',
        marginBottom: '4rem',
      }}
      gap={4}>
      {visible && (
        <DividendDropDownProducts
          investment={myInvestment}
          statusFilter={statusDividendFinfolio}
          handleClose={handleClose}
          refetch={refetch}
        />
      )}
      <InvestmentContentContainer>
        <ChartWrapper>
          <ChartnvestmentContainerProducts
            dataCharts={dataCharts}
            dividends={dividends}
            onChangeMonths={onChangeMonths}
            active={active}
            loadingGetSecurityPriceRange={loadingGetSecurityPriceRange}
          />
        </ChartWrapper>

        <InvestmentActionContainer>
          <BtnGroupContainer direction={'column'}>
            <BtnGroupFunds>
              <BtnContainer flexDirection={{ md: 'row', xs: 'column' }} gap={2}>
                <ButtonsSecondary
                  name={simulation}
                  onClick={() => handleRescueInvestment(idSelected)}
                  fullWidth
                  sx={{ whiteSpace: 'nowrap' }}
                />
                <ButtonsPrimary
                  name={investmentMore}
                  onClick={() => handleInvestMore(ModelId)}
                  fullWidth
                />
              </BtnContainer>

              {fileAs.products === true && statusDividendFinfolio.length > 0 && (
                <Stack
                  width={'100%'}
                  sx={{
                    paddingTop: '0px',
                    paddingLeft: '16px',
                    paddingRight: '16px',
                    paddingBottom: '16px',
                  }}>
                  {!visible ? (
                    <ButtonsTertiary
                      name='Reinvertir Dividendos'
                      endIcon={<KeyboardArrowRightIcon />}
                      fullWidth
                      onClick={handleOpen}
                      imgUrl='/assets/images/edit.svg'
                      sx={{ whiteSpace: 'nowrap' }}
                    />
                  ) : (
                    <ButtonsTertiary
                      name='Cancelar'
                      startIcon={<CloseIcon />}
                      endIcon={<KeyboardArrowDownIcon />}
                      fullWidth
                      onClick={handleClose}
                    />
                  )}
                </Stack>
              )}
            </BtnGroupFunds>
          </BtnGroupContainer>
          <Stack marginTop='16px'>
            <SectionGeneralCondition valorCuota={valorCuota} myInvestment={myInvestment} />
          </Stack>
        </InvestmentActionContainer>
      </InvestmentContentContainer>

      <CardContainerMovements>
        <ContentTitleTable>
          <TitleTableName>Cartola de movimientos</TitleTableName>
        </ContentTitleTable>
        <Box sx={{ width: '100%', my: 2 }}>
          <Tabs
            onChange={handleChange}
            value={value}
            aria-label='Tabs where selection follows focus'
            selectionFollowsFocus>
            <Tab sx={{ flex: '1 1 auto', textTransform: 'uppercase' }} label='Realizados' />
            <Tab sx={{ flex: '1 1 auto', textTransform: 'uppercase' }} label='Pendientes' />
          </Tabs>
        </Box>
        {value === 0 && (
          <TableInvertedProducts transactions={completedTransactions} colores={colores} />
        )}

        {value === 1 && (
          <TableInvertedProducts transactions={pendingTransactions} colores={colores} />
        )}
      </CardContainerMovements>
    </Stack>
  );
};

export default BodyInvertedProducts;
